// extracted by mini-css-extract-plugin
module.exports = {"navElement":"NavbarElement_navElement__NSzig","selected":"NavbarElement_selected__3VEqj"};